module.exports = __webpack_public_path__ + "static/media/14UNEP18.c4edd288.jpg";